// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SearchOutlinedSvg from "@ant-design/icons-svg/es/asn/SearchOutlined";
import AntdIcon from '../components/AntdIcon';

var SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlinedSvg
  }));
};

SearchOutlined.displayName = 'SearchOutlined';
export default /*#__PURE__*/React.forwardRef(SearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/SearchOutlined.js
// module id = 144
// module chunks = 0